import { template } from 'underscore';

import $ from '../../jquery';
import '../../bootstrap';

/**
 * jQuery UI widget for alert messages.
 *
 * Initiliaize:
 *     $('#alert-messages').alertMessages();
 *
 * Show an alert with the error style that disappears after the default time of 10 seconds:
 *     $('#alert-messages').alertMessages('add', 'error', 'Some Error Message');
 *
 * Show an alert that disappears after a custom time of 15 seconds
 *     $('#alert-messages').alertMessages('add', 'error', 'Some Error Message', 15000);
 *
 * @class jQuery.alertMessages
 */
$.widget('ofcs.alertMessages', {

    /**
     * The latest added message container
     * @property {jQuery} lastMessage
     */
    lastMessage: $([]),

    boundOnAjaxSuccess: null,

    /**
     * maxMessageTime:  Default time after which an message disappears automatically
     * template:        HTML-Template for new messages including <%= type %> and <%= message %>
     *                  which correspondent to the parameters of the add method
     *
     * @property options
     */
    options: {
        maxMessageTime: 10000,
        timoutAnimationSpeed: 1000,
        template: `
        <div class="alert-message-container">
            <div class="alert alert-<%= type %>">
                <button type="button" class="close" data-dismiss="alert">×</button><%= message %>
            </div>
        </div>`,
    },

    /**
     * Initializes the widget
     *
     * @private
     */
    _create() {
        this.boundOnAjaxSuccess = this.onAjaxSuccess.bind(this);
        $(document).on('ajaxSuccess', this.boundOnAjaxSuccess);
    },

    _destroy() {
        $(document).off('ajaxSuccess', this.boundOnAjaxSuccess);
    },

    onAjaxSuccess(event, response) {
        try {
            const data = JSON.parse(response.responseText);
            if (Object.keys(data).length === 2 && !!data.response && !!data.messages) {
                data.messages.forEach(message => this.add(message.type, message.message));
            }
        } catch (e) {
            try {
                const responseTextElement = $(response.responseText);
                const messages = responseTextElement.find('[data-message]');

                messages.each((idx, message) => {
                    const messageElement = $(message);
                    this.add(messageElement.data('type'), messageElement.html());
                });

                messages.remove();

                response.responseText = responseTextElement.html();
            } catch (innerError) {
                // Do nothing
            }
        }
    },

    /**
     * Adds a new message which is immediately shown and that is automatically
     * removed after a time given by maxMessageTime or the default time if
     * maxMessageTime is not passed
     *
     * @param {string} type
     * @param {string} message
     * @param {integer} maxMessageTime
     */
    add(type, message, maxMessageTime) {
        const messageContainer = $(template(this.options.template)({ type, message }));
        const messageElement = messageContainer.children(':first');
        const messageTime = maxMessageTime || this.options.maxMessageTime;

        this.lastMessage = messageElement;

        messageElement
            .alert()
            .on('closed', () => messageContainer.remove());

        this.element.prepend(messageContainer);
        messageContainer.height(messageElement.outerHeight(true));

        if (messageTime >= 0) {
            setTimeout(() => {
                messageContainer.trigger($.Event('hide'));
                messageContainer
                    .fadeOut(this.options.timoutAnimationSpeed, () => messageContainer.remove());
            }, messageTime);
        }
    },

    getLastMessage() {
        return this.lastMessage;
    },
});
